import { usePhasesList } from "@/application/use-cases/phases/use-phases.queries";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@monorepo-apps/ui/src/components/select";

const UNSCHEDULED_VALUE = "__unscheduled__";

interface WeekSelectProps {
  value: string | null;
  onChange: (phaseId: string | null) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

export function WeekSelect({ value, onChange, disabled, ariaLabel }: WeekSelectProps) {
  const phasesQ = usePhasesList();
  const phases = [...(phasesQ.data ?? [])].sort((a, b) => a.number - b.number);

  return (
    <Select
      value={value ?? UNSCHEDULED_VALUE}
      onValueChange={(v) => onChange(v === UNSCHEDULED_VALUE ? null : v)}
      disabled={disabled || phasesQ.isLoading}
    >
      <SelectTrigger aria-label={ariaLabel ?? "Week"}>
        <SelectValue placeholder="Select week" />
      </SelectTrigger>
      <SelectContent>
        {phases.map((p) => (
          <SelectItem key={p.id} value={p.id}>
            <span className="inline-flex items-center gap-2">
              <span className="font-data text-[10px] tracking-[0.16em] uppercase">W{p.number}</span>
              <span>{p.title}</span>
            </span>
          </SelectItem>
        ))}
        <SelectItem value={UNSCHEDULED_VALUE}>
          <span className="text-muted-foreground">Unscheduled</span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
